import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ProgressBar from '../common/progress-bar';
export default function CompletionProgress(_a) {
    var progress = _a.progress, total = _a.total;
    return _jsx(ProgressBar, { progress: progress, total: total });
}
